// extracted by mini-css-extract-plugin
module.exports = {"ErrorContainer":"Page_ErrorContainer__FMt4O","ErrorTitle":"Page_ErrorTitle__IF_Qp","ErrorMessage":"Page_ErrorMessage__23C1f"};